import { render, staticRenderFns } from "./ComplianceReport.vue?vue&type=template&id=b35a62be&scoped=true&"
import script from "./ComplianceReport.vue?vue&type=script&lang=js&"
export * from "./ComplianceReport.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceReport.vue?vue&type=style&index=0&id=b35a62be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35a62be",
  null
  
)

export default component.exports